import React from 'react';
import { MasterFilled, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import Styled from './SamplesCount.styled';

const SamplesCount = ({ samplesCount }: { samplesCount: number }) => {
    return (
        <Styled.Wrapper>
            <MasterFilled size="sm" />
            <Text ml="xs" size="sm">
                <Trans>{samplesCount} / 8 samples</Trans>
            </Text>
        </Styled.Wrapper>
    );
};

export default SamplesCount;
